import * as React from 'react';

export const ThirdPartyEmbeds = () => {
    return (
        <>
            <script type="text/javascript" src="https://a.omappapi.com/app/js/api.min.js" data-account="103414" data-user="92156" async></script>
        </>
    )
}